export const googleAnalyticsNormalAction = (
    eventName: string,
    category: string,
    action: string,
    label: string,
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
    });
};

export const googleAnalyticsQuoteButton = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    quotationId: string,
    applicationType: string,
    propertyType: string,
    noOfStoreys: string,
    constructionType: string,
    unOccupiedFor90Days: string,
    sufferedAnyLoss: string,
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
        quotation_id: quotationId,
        application_type: applicationType,
        property_type: propertyType,
        no_of_storeys: noOfStoreys,
        construction_type: constructionType,
        unoccupied_for_90_days: unOccupiedFor90Days,
        suffered_any_loss: sufferedAnyLoss,
    });
};

export const googleAnalyticsSubmitDeclare = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    maximumDeclarableAmount: string,
    totalDeclarableAmount: string,
    undeclaredAmount: string
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
        maximum_declarable_amount: maximumDeclarableAmount,
        total_declare_amount: totalDeclarableAmount,
        undeclared_amount: undeclaredAmount
    });
};

export const googleAnalyticsWithQuotationDetails = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    priceCurrency: string,
    itemPrice: number,
    planAndAddonDetails: any,
    transactionId?: string,
) => {
    return;
    if (transactionId !== undefined) {
        window.dataLayer.push({
            event: eventName,
            event_category: category,
            event_action: action,
            event_label: label,
            ecommerce: {
                transaction_id: transactionId,
                currency: priceCurrency,
                value: itemPrice,
                items: planAndAddonDetails,
            },
        });
    } else {
        window.dataLayer.push({
            event: eventName,
            event_category: category,
            event_action: action,
            event_label: label,
            ecommerce: {
                currency: priceCurrency,
                value: itemPrice,
                items: planAndAddonDetails,
            },
        });
    }
};

export const googleAnalyticsWithPersonalDetails = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    quotationId: string,
    hashName: string,
    idType: string,
    hashIdNumber: string,
    nationality: string,
    birthDate: string,
    gender: string,
    race: string,
    hashPhoneNumber: string,
    hashEmail: string,
    hashPropertyAddress: string,
    hashMailingAddress: string,
    bankName: string,
    hashAccountNumber: string,
    priceCurrency: string,
    itemPrice: number,
    planAndAddonDetails: any
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
        quotation_id: quotationId,
        hash_name: hashName,
        id_type: idType,
        hash_id_number: hashIdNumber,
        nationality,
        birth_date: birthDate,
        gender,
        race,
        hash_phone_number: hashPhoneNumber,
        hash_email: hashEmail,
        hash_property_address: hashPropertyAddress,
        hash_mailing_address: hashMailingAddress,
        bank_name: bankName,
        hash_account_number: hashAccountNumber,
        ecommerce: {
            currency: priceCurrency,
            value: itemPrice,
            items: planAndAddonDetails,
        },
    });
};

export const googleAnalyticsAddPaymentInfo = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    eventCurrency: string,
    itemPrice: number,
    coupon: string,
    paymentType: string,
    planAndAddonDetails: any,
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
        ecommerce: {
            currency: eventCurrency,
            value: itemPrice,
            coupon,
            payment_type: paymentType,
            items: planAndAddonDetails,
        },
    });
};

export const googleAnalyticsPurchaseSuccessPage = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    profit: number | undefined,
    eventCurrency: string,
    itemPrice: number,
    coupon: string,
    transactionId: string,
    planAndAddonDetails: any,
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
        profit: profit,
        event_currency: eventCurrency,
        ecommerce: {
            currency: eventCurrency,
            value: itemPrice,
            coupon,
            transaction_id: transactionId,
            items: planAndAddonDetails,
        },
    });
};

export const createProductItem = (
    itemId: string,
    itemName: string,
    itemBrand: string,
    itemCategory: string,
    itemCategory2: string,
    itemCategory3: string,
    itemCategory4: string,
    currency: string,
    price: number,
    quantity: number,
    coupon: string,
    coverageType: string,
) => {
    return {
        item_id: itemId,
        item_name: itemName,
        item_brand: itemBrand,
        item_category: itemCategory,
        item_category2: itemCategory2,
        item_category3: itemCategory3,
        item_category4: itemCategory4,
        currency,
        price,
        quantity,
        coupon,
        coverage_type: coverageType,
    };
};

export const createProductItemWithEPolicyNumber = (
    itemId: string,
    itemName: string,
    itemBrand: string,
    itemCategory: string,
    itemCategory2: string,
    itemCategory3: string,
    itemCategory4: string,
    currency: string,
    price: number,
    quantity: number,
    coupon: string,
    epolicyNumber: string,
    coverageType: string,
) => {
    return {
        item_id: itemId,
        item_name: itemName,
        item_brand: itemBrand,
        item_category: itemCategory,
        item_category2: itemCategory2,
        item_category3: itemCategory3,
        item_category4: itemCategory4,
        currency,
        price,
        quantity,
        coupon,
        epolicy_number: epolicyNumber,
        coverage_type: coverageType,
    };
};

export const googleAnalyticsMyRumahBeginQuotation = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    userId: string | undefined,
    gaClientId: string | undefined
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
        user_id: userId,
        ga_client_id: gaClientId
    });
};

export const googleAnalyticsMyRumahQuoteButton = (
    eventName: string,
    category: string,
    action: string,
    label: string,
    idType: string,
    hashIdNumber: string,
    nationality: string,
    birthDate: string,
    unOccupiedFor90Days: string,
    sufferedAnyLoss: string,
    propertyRegisteredUnderHouseOwner: string,
    currency: string,
    itemPrice: number,
    planAndAddonDetails: any,
) => {
    return;
    window.dataLayer.push({
        event: eventName,
        event_category: category,
        event_action: action,
        event_label: label,
        id_type: idType,
        hash_id_number: hashIdNumber,
        nationality: nationality,
        birth_date: birthDate,
        unoccupied_for_90_days: unOccupiedFor90Days,
        suffered_any_loss: sufferedAnyLoss,
        property_registered_under_house_owner: propertyRegisteredUnderHouseOwner,
        ecommerce: {
            currency,
            value: itemPrice,
            items: planAndAddonDetails
        }
    });
};

export const createMyRumahProductItems = (
    itemId: string,
    itemName: string,
    itemBrand: string,
    itemCategory: string,
    itemCategory2: string,
    itemCategory3: string,
    itemCategory4: string,
    currency: string,
    price: number,
    quantity: number,
    coupon: string,
    itemBillingType: string | undefined,
    constructionType: string,
    coverageStartDate: string,
    noOfStoreys: string
) => {
    return {
        item_id: itemId,
        item_name: itemName,
        item_brand: itemBrand,
        item_category: itemCategory,
        item_category2: itemCategory2,
        item_category3: itemCategory3,
        item_category4: itemCategory4,
        currency,
        price,
        quantity,
        coupon,
        item_billing_type: itemBillingType,
        construction_type: constructionType,
        coverage_start_date: coverageStartDate,
        no_of_storeys: noOfStoreys
    };
};